__turbopack_context__.v({
  "columnLeft": "EddPanel-module__szmb8G__columnLeft",
  "columnLeftLandscape": "EddPanel-module__szmb8G__columnLeftLandscape",
  "columnRight": "EddPanel-module__szmb8G__columnRight",
  "columnRightLandscape": "EddPanel-module__szmb8G__columnRightLandscape",
  "container": "EddPanel-module__szmb8G__container",
  "containerLandscape": "EddPanel-module__szmb8G__containerLandscape",
  "eddTimeRangeContainer": "EddPanel-module__szmb8G__eddTimeRangeContainer",
});
